import React, {ReactElement} from 'react';
import {useIntl} from 'react-intl';
import {cx} from '@emotion/css';

import HubPageLink, {HubPageLinkProps} from '../DesignSystem/HubPageLink/HubPageLink';
import Headers, {HeaderType} from '../DesignSystem/Text/Headers/Headers';
import {Alignment} from '../../types';

import styles from './RecommendedHubs.styles';

interface RecommendedHubsProps {
  hubs: HubPageLinkProps[];
}

function RecommendedHubs({hubs}: RecommendedHubsProps): ReactElement {
  const {formatMessage} = useIntl();
  const hubKeys = Object.keys(hubs);
  return (
    <div className={cx(styles.container)}>
      <Headers headerType={HeaderType.H2} alignment={Alignment.CENTER}>
        {formatMessage({id: 'knowledgePages.label.recommendedHubs.title'})}
      </Headers>
      <div className={cx(styles.list)}>
        {hubs.map((hub, i) => {
          const key = hubKeys[i];
          return (
            <HubPageLink
              key={`hub-${key}`}
              title={hub.title}
              imageSrc={hub.imageSrc}
              href={hub.href}
              className={cx(styles.link)}
            />
          );
        })}
      </div>
    </div>
  );
}

export default RecommendedHubs;
